import router from './index'
import store from '../store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import {getToken, setToken} from 'vue-django/src/utils/auth' // getToken from cookie

NProgress.configure({showSpinner: false})// NProgress Configuration
const loginUrl = '/auth/login'
const continueViews = store.state.continueViews || []

router.beforeEach((to, from, next) => {
        NProgress.start() // start progress bar
        let loginRequired = (to.path === loginUrl) ? false : (to.matched.some(record => record.meta.loginRequired !== false))
        if (!loginRequired) {
            next()
        } else {
            let token = getToken()
            if (token && !store.state.token) {
                store.state.token = token
                setToken(token)
            }
            let user = store.state.user
            let logined = user && user.id
            if (!logined) {
                store.dispatch('getUserInfo').then(({data}) => {
                    user = store.state.user
                    const roles = user.groups
                    // router.addRoutes(asyncRouterMap) //todo: make dynamics routers
                    next({...to, replace: true}) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                }).catch((error) => {
                    Vue.$message({message: '身份认证失败, 请重新登录', type: 'error'})
                    next({path: loginUrl, query: {redirect: to.fullPath}})
                })
            } else {
                // 权限判断
                const allowRoles = to.meta.roles
                let isAllowed = true

                if (isAllowed) {
                    next()
                } else {
                    next({path: '/notallow'})
                }
            }
        }
    }
)

const CU = 'continueurl'

function continueLastUrl(to, from) {
    try {
        if (continueViews.includes(to.name)) {
            localStorage.setItem(CU, to.fullPath)
        } else if (continueViews.includes(from.name)) {
            let ua = window.navigator.userAgent
            if ((/MicroMessenger/i).test(ua) && (/iphone/i).test(ua)) {
                // 苹果微信会在关闭窗口时再一次访问 index, 这里要忽略, 不能删除历史
                if (to.name !== 'index') {
                    localStorage.removeItem(CU)
                }
            } else {
                localStorage.removeItem(CU)
            }
        }
    } catch (e) {
        Vue.$message({message: e.toString()})
        console.log(e)
    }
}
router.afterEach((to, from) => {
    NProgress.done()
    if (to.name !== null && from.name !== null) {
        continueLastUrl(to, from)
    }
})

router.onError((err) => {
    NProgress.done()
    console.error(err)
    Vue.$message({message: `发生异常:${err}`, type: 'error'})
})



// WEBPACK FOOTER //
// ./src/router/permission.js